var _defs, _path, _path2, _path3, _polyline, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForm3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.39 113.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#d89f5b;stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,85.74v-7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,78.74v7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.79,90.24v-1.7a2.8,2.8,0,0,1,2.8-2.8h24.7a2.8,2.8,0,0,1,2.8,2.8v1.7Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "61.49 70.64 6.79 70.64 6.79 29.14 77.19 29.14 77.19 33.24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.09,35.24v-7.3a2.8,2.8,0,0,0-2.8-2.8H5.59a2.8,2.8,0,0,0-2.8,2.8v48a2.8,2.8,0,0,0,2.8,2.8h58.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.79,44.54V38a2.8,2.8,0,0,0-2.8-2.8H67.29a2.8,2.8,0,0,0-2.8,2.8v49.4a2.86,2.86,0,0,0,2.8,2.8H96a2.8,2.8,0,0,0,2.8-2.8V85"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.49,40.34h34.4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.49,81.64H87.34"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.49,85.74h3.9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.39,82.24V49.34a2.8,2.8,0,0,1,2.8-2.8h14.5a2.8,2.8,0,0,1,2.8,2.8v32.9a2.8,2.8,0,0,1-2.8,2.8H93.19A2.73,2.73,0,0,1,90.39,82.24Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.39,50.24h20.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.39,78.74h20.2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.39,81.64h2.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm3);
export default __webpack_public_path__ + "static/media/form_3.022a84de238ec20637eebd0f2b72e920.svg";
export { ForwardRef as ReactComponent };